import React from 'react';
import PropTypes from 'prop-types';

export const getVenue = (session) => {
    if (session && session.locationId && session.location) {
        const sublocationNameIfExists = session.sublocationId && session.sublocation && session.sublocation.name && `, ${session.sublocation.name}` || '';
        return `${session.location.name}${sublocationNameIfExists} `;
    } else {
        return '';
    }
} ;

const SessionLocation = ({ session = {}, cls }) => {
    const venue = getVenue(session);
    if (venue !== '') {
        return (
            <div className={`session-location ${cls}`}>
                <i className="location-icon fa icon-locator2 custom-color color-1 font-size-16"/>
                {venue}
            </div>
        );
    } else {
        return null;
    }
};

SessionLocation.propTypes = {
    session: PropTypes.object.isRequired,
    cls: PropTypes.string
};

export default SessionLocation;
